'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Button } from '../Button/Button';
import { FieldControl } from '../client/forms/Field/FieldControl';
import { Input } from '../Input/Input';
import { Pill } from '../Pill/Pill';
import { Row } from '../server/layout/Row/index';
import { Stack } from '../server/layout/Stack/index';
import { I } from '../system/icons';
const trimmed = (raw) => raw.trim();
const itself = (tag) => tag;
// Free-text tags: type one, Enter or Add puts it in the list, each tag's ×
// takes it out. Leaving the box adds what is typed too, so a tag typed and
// never confirmed is not lost when the form around it saves. A tag already in
// the list (by keyOf) is not added twice; the text box clears either way.
export function TagInput({ value, onChange, placeholder, addLabel, removeLabel, inputLabel, normalize = trimmed, keyOf = itself, max, maxLength, disabled = false, renderTags, tagSelectedTone, tagSize = 'xs', wide = false, }) {
    const [draft, setDraft] = useState('');
    const full = max !== undefined && value.length >= max;
    const off = disabled || full;
    // Something typed that Add would put in the list: Add turns primary, the
    // one action the box is waiting on.
    const ready = !off && normalize(draft).length > 0;
    const add = () => {
        const tag = normalize(draft);
        if (tag.length === 0 || off)
            return;
        const key = keyOf(tag);
        if (!value.some((t) => keyOf(t) === key))
            onChange([...value, tag]);
        setDraft('');
    };
    const pills = value.length > 0
        ? value.map((tag) => (_jsx(Pill, { size: tagSize, ...(tagSelectedTone === undefined ? {} : { selected: true, selectedTone: tagSelectedTone }), onRemove: disabled ? undefined : () => onChange(value.filter((t) => t !== tag)), removeAriaLabel: removeLabel(tag), children: tag }, keyOf(tag))))
        : null;
    const box = (_jsxs(Row, { gap: "sm", align: "center", children: [_jsx(FieldControl, { children: _jsx(Input, { value: draft, onChange: (e) => setDraft(e.target.value), onBlur: add, onKeyDown: (e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            add();
                        }
                    }, placeholder: placeholder, "aria-label": inputLabel, maxLength: maxLength, disabled: off, ...(wide
                        ? {
                            icon: I.plus,
                            style: { flex: '1 1 auto', maxWidth: '22rem', borderRadius: 'var(--radius-full)' },
                        }
                        : { style: { maxWidth: 240 } }) }) }), wide ? (_jsx(Button, { variant: ready ? 'primary' : 'secondary', size: "md", onClick: add, disabled: !ready, children: addLabel })) : (
            // Button md: the box beside it is an Input md, and the two share a row.
            _jsx(Button, { variant: ready ? 'primary' : 'ghost', size: "md", icon: I.plus, onClick: add, disabled: !ready, children: addLabel }))] }));
    if (renderTags !== undefined) {
        return (_jsxs(Stack, { gap: "md", children: [renderTags(pills), box] }));
    }
    return (_jsxs(Stack, { gap: "sm", children: [box, pills === null ? null : (_jsx(Row, { gap: "sm", wrap: true, align: "center", children: pills }))] }));
}
//# sourceMappingURL=TagInput.js.map